module.exports = __webpack_public_path__ + "img/loading.d0783985.gif";